<template>
    <section>
        <Header title="Dashboard"></Header>
        <v-container>
            <p v-if="isLoading" class="text-center my-7"><v-icon large color="primary">fal fa-spinner-third fa-spin</v-icon></p>
            <section v-if="!isLoading && mainFacet && isManager">
<!--                <p class="mt-2 mb-4">Kies een functiecategorie:</p>-->
                <p class="mt-2 mb-4">Kandidaten:</p>
                <ul class="main-facet-overview mx-lg-n1">
                    <li
                        v-for="choice in mainFacet.choices" :key="choice.id" @click="openMainFacetChoice(choice)"
                        class="my-1 mx-lg-1 d-block d-lg-inline-block"
                    >
                        <v-btn
                            block
                            elevation="0"
                        >
                            {{ choice.value }}
                        </v-btn>
                    </li>
                </ul>
            </section>
            <section v-if="!isLoading && mainFacet" class="mt-5">
                <p class="mt-2 mb-4">Diensten- en activiteitenaanbod:</p>
                <ul class="main-facet-overview mx-lg-n1">
                    <li
                        @click="openOrganisations('starters')"
                        class="my-1 mx-lg-1 d-block d-lg-inline-block"
                    >
                        <v-btn
                            block
                            elevation="0"
                        >
                            Speciaal voor starters
                        </v-btn>
                    </li>
                    <li
                        @click="openOrganisations('professional')"
                        class="my-1 mx-lg-1 d-block d-lg-inline-block"
                    >
                        <v-btn
                            block
                            elevation="0"
                        >
                            Professionalisering
                        </v-btn>
                    </li>
                    <li
                        @click="openOrganisations('sustainable_employability')"
                        class="my-1 mx-lg-1 d-block d-lg-inline-block"
                    >
                        <v-btn
                            block
                            elevation="0"
                        >
                            Duurzame inzetbaarheid
                        </v-btn>
                    </li>
                </ul>
            </section>
            <section v-if="!isLoading && mainFacet" class="mt-5">
                <p class="mt-2 mb-4">Good Practices:</p>
                <ul class="main-facet-overview mx-lg-n1">
                    <li
                        @click="openGoodPractices()"
                        class="my-1 mx-lg-1 d-block d-lg-inline-block"
                    >
                        <v-btn
                            block
                            elevation="0"
                        >
                            Good Practices
                        </v-btn>
                    </li>
                </ul>
            </section>
            <v-alert v-if="!isLoading && !mainFacet" color="warning">
                <v-icon class="mr-3">fal fa-exclamation-triangle</v-icon> Controleer uw internetverbinding en/of probeer het later opnieuw.
            </v-alert>
        </v-container>
    </section>
</template>

<script>
import Header from "@/components/layout/Header";
import {mapState} from "vuex";

export default {
    name: 'Home',
    components: {
        Header,
    },
    data: () => ({
        isLoading: true,
    }),
    computed: {
        mainFacet () {
            // Functiecategorieën
            return this.facets.find(facet => facet.id === 1);
        },
        ...mapState({
            facets: state => state.profile.facets,
            isLoggedIn: state => state.auth.isLoggedIn,
            user: state => state.auth.user,
        }),
        isManager () {
            return this.user && this.user.role === 'manager';
        },
    },
    mounted () {
        if (this.isLoggedIn) {
            this.$store.dispatch('updateProfiles')
                .catch(e => {
                    console.error(e);
                    return this.$store.dispatch('showSnackbar', {
                        color: 'error',
                        text: 'Profielen konden niet worden opgehaald'
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    },
    methods: {
        openMainFacetChoice (facetChoice) {
            let query = {};
            query['filter'+this.mainFacet.id] = facetChoice.id;
            this.$router.push({name: 'Profiles', query: query});
        },
        openOrganisations (type) {
            this.$router.push({name: 'Organisations', query: { type }});
        },
        openGoodPractices () {
            this.$router.push({name: 'GoodPractices'});
        },
    },
}
</script>
